import React from "react";
import Table from "../Table";
import { Link } from "react-router-dom";

import hasACL from "../../util/hasACL";

function CobrandsTable(props) {
  const columns = [
    {
      name: "Cobrand ID",
      selector: "id",
      sortable: true,
      ignoreRowClick: true
    },
    {
      name: "Cobrand Name",
      selector: "name",
      sortable: true,
      ignoreRowClick: true,
      keyField: "id",
      cell: row => {
        return (
          <Link
            to={
              hasACL("VW_SNP_MGMT")
                ? "/applications/" + row.id
                : "/reports/" + row.id
            }
            onClick={() => localStorage.setItem("cobrandId", row.id)}
          >
            {row.name}
          </Link>
        );
      }
    }
  ];
  return (
    <Table
      columns={columns}
      data={props.data}
      pagination={true}
      paginationPerPage={props.paginationPerPage}
      paginationRowsPerPageOptions={[25, 50, 75, 100]}
    />
  );
}

export default CobrandsTable;
